export const sectionsOnStageActionTypes = {
  SET_HOVERED_SECTION_INDEX: 'SET_HOVERED_SECTION_INDEX',
  SET_SECTIONS: 'SET_SECTIONS',
};
